// extracted by mini-css-extract-plugin
export var relativeWrapper = "News-module--relativeWrapper--3h9Cc";
export var decor = "News-module--decor--oGX4r";
export var container = "News-module--container--2bEr3";
export var newsSources = "News-module--newsSources--3S7JC";
export var logoList = "News-module--logoList--39V9_";
export var logo = "News-module--logo--_M40W";
export var articleQuote = "News-module--articleQuote--MAcfX";
export var tag = "News-module--tag--Gld0_";
export var link = "News-module--link--2kCob";